import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetCustomersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/get-customers-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterCustomerListContext } from '../../customer.context';
import { CustomerListFilterFormStep1Controller } from '../customer-list-filter-form-step-1/customer-list-filter-form-step-1.controller';

export interface CustomerListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetCustomersPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetCustomersPaginatedModel>;
  onCancel: () => void;
}

export const CustomerListFilterFormController = (
  props: CustomerListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterCustomerListContext();

  return (
    <MultiStepFormProvider<GetCustomersPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: ['isExemptFromBilling'],
          component: <CustomerListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
